import { __awaiter, __generator } from "tslib";
import { isUrl } from '../utils';
import createTheme from './createTheme';
import options from './options.json';
/** @deprecated never use that anymore */
var RcThemeHandler = /** @class */ (function () {
    function RcThemeHandler() {
        this.themeCache = new Map();
        this.themeProviderRef = 0;
    }
    RcThemeHandler.getInstance = function () {
        if (!RcThemeHandler.instance) {
            RcThemeHandler.instance = new RcThemeHandler();
        }
        return RcThemeHandler.instance;
    };
    RcThemeHandler.prototype.listen = function (cb) {
        this.emit = cb;
    };
    RcThemeHandler.prototype.destroy = function () {
        RcThemeHandler.instance = undefined;
    };
    RcThemeHandler.prototype.getTheme = function () {
        return this.currentTheme;
    };
    /** Set Theme with theme object */
    RcThemeHandler.prototype.setTheme = function (themeOptions, isEmit) {
        if (isEmit === void 0) { isEmit = true; }
        var currentKey = JSON.stringify(themeOptions);
        var currentTheme = this.themeCache.get(currentKey);
        if (currentTheme) {
            this.currentTheme = currentTheme;
        }
        else {
            var theme = createTheme(themeOptions);
            this.themeCache.set(currentKey, theme);
            this.currentTheme = theme;
        }
        if (isEmit && this.emit) {
            this.emit(this.currentTheme);
        }
        return this.currentTheme;
    };
    /** Set Theme Name with read static json file */
    RcThemeHandler.prototype.setThemeName = function (name) {
        return __awaiter(this, void 0, void 0, function () {
            var theme;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.read(name)];
                    case 1:
                        theme = _a.sent();
                        this.setTheme(theme);
                        return [2 /*return*/];
                }
            });
        });
    };
    RcThemeHandler.prototype.read = function (theme) {
        // If that is pass url into, using that file directly.
        if (isUrl(theme)) {
            return this.loadUrl(theme);
        }
        return this.loadUrl("" + options.basePath + theme + ".json");
    };
    RcThemeHandler.prototype.loadUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 7, , 9]);
                        return [4 /*yield*/, fetch(url, { cache: 'force-cache' })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 5];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(new Error("failed parsing " + url + " to json"))];
                    case 5: return [4 /*yield*/, Promise.reject(new Error("failed loading " + url))];
                    case 6: return [2 /*return*/, _a.sent()];
                    case 7:
                        e_2 = _a.sent();
                        return [4 /*yield*/, Promise.reject(new Error("failed loading " + url))];
                    case 8: return [2 /*return*/, _a.sent()];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    return RcThemeHandler;
}());
export { RcThemeHandler };
